/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JSONPatchOperation } from './JSONPatchOperation';
import {
    JSONPatchOperationFromJSON,
    JSONPatchOperationFromJSONTyped,
    JSONPatchOperationToJSON,
} from './JSONPatchOperation';

/**
 * 
 * @export
 * @interface PatchObjectConfigContentRequest
 */
export interface PatchObjectConfigContentRequest {
    /**
     * The ID of the user group that has access to this installation.
     * Either groupRef or installationId must be provided.
     * @type {string}
     * @memberof PatchObjectConfigContentRequest
     */
    groupRef: string;
    /**
     * The action type for the object config (read, subscribe, or write).
     * @type {string}
     * @memberof PatchObjectConfigContentRequest
     */
    action: PatchObjectConfigContentRequestActionEnum;
    /**
     * Array of JSON Patch operations to apply.
     * @type {Array<JSONPatchOperation>}
     * @memberof PatchObjectConfigContentRequest
     */
    changes: Array<JSONPatchOperation>;
    /**
     * The installation ID.
     * Either groupRef or installationId must be provided.
     * @type {string}
     * @memberof PatchObjectConfigContentRequest
     */
    installationId: string;
}


/**
 * @export
 */
export const PatchObjectConfigContentRequestActionEnum = {
    Read: 'read',
    Subscribe: 'subscribe',
    Write: 'write'
} as const;
export type PatchObjectConfigContentRequestActionEnum = typeof PatchObjectConfigContentRequestActionEnum[keyof typeof PatchObjectConfigContentRequestActionEnum];


/**
 * Check if a given object implements the PatchObjectConfigContentRequest interface.
 */
export function instanceOfPatchObjectConfigContentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "groupRef" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "changes" in value;
    isInstance = isInstance && "installationId" in value;

    return isInstance;
}

export function PatchObjectConfigContentRequestFromJSON(json: any): PatchObjectConfigContentRequest {
    return PatchObjectConfigContentRequestFromJSONTyped(json, false);
}

export function PatchObjectConfigContentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchObjectConfigContentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupRef': json['groupRef'],
        'action': json['action'],
        'changes': ((json['changes'] as Array<any>).map(JSONPatchOperationFromJSON)),
        'installationId': json['installationId'],
    };
}

export function PatchObjectConfigContentRequestToJSON(value?: PatchObjectConfigContentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupRef': value.groupRef,
        'action': value.action,
        'changes': ((value.changes as Array<any>).map(JSONPatchOperationToJSON)),
        'installationId': value.installationId,
    };
}

